// import PageContentData from './cb-page-context-data.json'
// import ServiceData from './cb-service-data.json'
// import AffiliationData from './affiliation-data.json'
//import  PromoCodesData from  './pb-promo-codes-data.json'

const getPageContentData = () => {
    if(window.pageContentData || window.pageContextData || window.hsGradPageContentData) {
        return window.pageContentData || window.pageContextData || window.hsGradPageContentData
    } else {
        console.log("No Page Context Data found on page. Reverting to LOCAL JSON data.")
        return []//PageContentData
    }
}

const getCatalogBrowseData = () => {
    if(window.catalogBrowseData || window.serviceData || window.hsGradServiceData) {
        return window.catalogBrowseData || window.serviceData || window.hsGradServiceData
    } else {
        console.log("No Service Data found on page. Reverting to LOCAL JSON data.")
        return {}//ServiceData
    }
}

const getAffiliationData = () => {
    if(window.affiliationData) {
        return window.affiliationData
    } else {
        return {}//AffiliationData
    }
}
const getPromoCodesData = () => {
    if(window.promocodes ) {
        return window.promocodes
    } else {
        return []//PromoCodesData
    }
}

export const AppData = {
    catalogBrowseData: getCatalogBrowseData(),
    pageContentData: getPageContentData(),
    affiliationData: getAffiliationData(),
    PromoCodesData: getPromoCodesData()
}
